<div class="main-container">
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <mat-card appearance="outlined">
      <mat-card-title>Template Settings</mat-card-title>
      <mat-card-content>
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">
          Error occurred
        </div>

        <app-mat-checkbox-input [formControl]="isPublicControl" label="Public" name="isPublic" [submitted]="submitted"
                                *ngIf="hasPublicEditAccess" [disabled]="!hasPrivateEditAccess"></app-mat-checkbox-input>
        <app-mat-simple-select formControlName="category"
                               label="Category"
                               style="width: 200px; display: block"
                               [selectItems]="templateService.categories"
                               [hideRequiredMarker]="true"></app-mat-simple-select>
        <app-mat-number-input [formControl]="orderControl" label="Order" name="order"
                              explanation="Higher number will bring template to top of list"
                            [submitted]="submitted" style="width: 200px; display: block"></app-mat-number-input>
        <app-mat-text-input [formControl]="nameControl" label="Name" name="name"
                            [submitted]="submitted"></app-mat-text-input>
        <app-mat-textarea-input [formControl]="messageControl" label="Message" name="message"
                                [submitted]="submitted"></app-mat-textarea-input>
      </mat-card-content>
      <mat-card-actions fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <button mat-raised-button type="submit" color="primary" matTooltip="Save changes"
                [promiseBtn]="buttonSubmitPromise" *ngIf="hasEditAccess">Save
        </button>
        <button mat-raised-button class="only-icon" color="warn" type="button" matTooltip="Remove template"
                *ngIf="(hasDeleteAccess) && model.id && model.id !== 'new'"
                (click)="onDeleteClick()">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
